import { render, staticRenderFns } from "./SaveAllPassDialog.vue?vue&type=template&id=6fd2956b&scoped=true"
import script from "./SaveAllPassDialog.vue?vue&type=script&lang=js"
export * from "./SaveAllPassDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd2956b",
  null
  
)

export default component.exports